(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('store-locator')) return;

    const normalize = (s) =>
      (s || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const haversine = (lat1, lon1, lat2, lon2) => {
      const R = 6371;
      const toRad = (d) => (d * Math.PI) / 180;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(a));
    };

    class StoreLocator extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-ref="input"]');
        this.form = this.querySelector('[data-ref="form"]');
        this.grid = this.querySelector('[data-ref="grid"]');
        this.empty = this.querySelector('[data-ref="empty"]');
        this.status = this.querySelector('[data-ref="status"]');
        this.geoButton = this.querySelector('[data-ref="geoButton"]');
        this.cards = this.grid ? Array.from(this.grid.querySelectorAll('.store-card')) : [];

        this.cards.forEach((card, i) => (card.dataset.order = i));
        this.sortByName();

        this.form?.addEventListener('submit', (e) => e.preventDefault());
        this.input?.addEventListener('input', () => this.filter());
        this.geoButton?.addEventListener('click', () => this.locate());
      }

      sortByName() {
        this.cards
          .slice()
          .sort((a, b) => (/sede cartaxo/i.test(b.dataset.name) - /sede cartaxo/i.test(a.dataset.name)) || a.dataset.name.localeCompare(b.dataset.name, 'pt')) // Sede Cartaxo primeiro, depois ordem alfabetica
          .forEach((card) => this.grid.appendChild(card));
      }

      /* Pontuação de relevância de um cartão para a pesquisa */
      score(card, q, terms) {
        const loc = card.dataset.localidade || normalize(card.dataset.name); // se a localidade estiver vazia, usa o nome da loja
        const dist = card.dataset.distrito;
        const cp = card.dataset.cp || ((card.dataset.search || '').match(/\b(\d{4}) (\d{3})\b/) || []).slice(1, 3).join('-'); // ex: 2080-104 (se o campo estiver vazio, usa o codigo postal da morada)
        const cp4 = cp.slice(0, 4);
        const cp2 = cp.slice(0, 2);
        const hay = card.dataset.search;
        const digits = q.replace(/\D/g, '');

        // Pesquisa numérica (código postal)
        if (digits.length >= 2 && /^[\d\s-]+$/.test(q)) {
          if (cp.replace('-', '').startsWith(digits)) return 100;
          if (digits.length >= 4 && cp4 === digits.slice(0, 4)) return 90;
          if (digits.length >= 2 && cp2 === digits.slice(0, 2)) return 40; // mesma zona
          return 0;
        }

        let s = 0;
        if (loc === q || dist === q) s = 100;
        else if (loc.startsWith(q) || dist.startsWith(q)) s = 80;
        else if (terms.every((t) => loc.includes(t) || dist.includes(t))) s = 70;
        else if (terms.every((t) => hay.includes(t))) s = 50;
        return s;
      }

      filter() {
        const q = normalize(this.input.value);
        const terms = q.split(' ').filter(Boolean);

        this.cards.forEach((c) => {
          const z = c.querySelector('.store-card__zone');
          if (z) z.textContent = '';
        });

        if (!q) {
          this.cards.forEach((c) => (c.hidden = false));
          this.sortByName();
          if (this.empty) this.empty.hidden = true;
          this.status.textContent = '';
          return;
        }

        const scored = this.cards.map((card) => ({ card, s: this.score(card, q, terms) }));
        const visible = scored.filter((x) => x.s > 0);
        const exact = visible.filter((x) => x.s >= 70).length;

        scored.forEach(({ card, s }) => {
          card.hidden = s === 0;
          const z = card.querySelector('.store-card__zone');
          if (z && s > 0 && s < 70 && exact === 0) z.textContent = 'na mesma zona';
        });

        visible
          .sort((a, b) => b.s - a.s || a.card.dataset.name.localeCompare(b.card.dataset.name, 'pt'))
          .forEach(({ card }) => this.grid.appendChild(card));

        if (this.empty) this.empty.hidden = visible.length > 0;
        this.status.textContent =
          visible.length === 0
            ? ''
            : exact === 0
              ? `Sem loja exata para "${this.input.value.trim()}" — a mostrar ${visible.length} ${visible.length === 1 ? 'loja' : 'lojas'} na mesma zona`
              : `${visible.length} ${visible.length === 1 ? 'loja encontrada' : 'lojas encontradas'}`;
      }

      locate() {
        if (!('geolocation' in navigator)) {
          this.status.textContent = 'O seu browser não suporta localização.';
          return;
        }
        this.geoButton.setAttribute('aria-busy', 'true');
        this.status.textContent = 'A obter a sua localização…';
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const { latitude, longitude } = pos.coords;
            this.input.value = '';
            this.cards.forEach((card) => {
              card.hidden = false;
              const lat = parseFloat(card.dataset.lat);
              const lng = parseFloat(card.dataset.lng);
              const badge = card.querySelector('.store-card__distance');
              if (Number.isFinite(lat) && Number.isFinite(lng)) {
                const km = haversine(latitude, longitude, lat, lng);
                card.dataset.distance = km;
                if (badge) badge.textContent = km < 10 ? `${km.toFixed(1)} km` : `${Math.round(km)} km`;
              } else {
                card.dataset.distance = Number.MAX_SAFE_INTEGER;
                if (badge) badge.textContent = '';
              }
            });
            this.cards
              .slice()
              .sort((a, b) => parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance))
              .forEach((card) => this.grid.appendChild(card));
            if (this.empty) this.empty.hidden = true;
            this.status.textContent = 'Lojas ordenadas da mais próxima para a mais distante.';
            this.geoButton.removeAttribute('aria-busy');
          },
          () => {
            this.status.textContent = 'Não foi possível obter a sua localização. Verifique as permissões do browser.';
            this.geoButton.removeAttribute('aria-busy');
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      }
    }

    customElements.define('store-locator', StoreLocator);
  })();

  } catch(e) { console.error(e); }
})();
})();
